import { getFilenameFromUrl } from '../helpers/functions';
import { findIndex } from 'lodash';
import { Amenity } from './Hotel';
import BaseModel from './BaseModel';
export default class HomestayRoomType extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }
    
    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.area = data.area || 0;
        this.shortDescription = data.shortDescription || this.translate.shortDescription || undefined;
        this.code = data.code || undefined;
        this.userId = data.userId || undefined;
        this.description = data.description || this.translate.description || undefined;
        this.maxOccupancy = data.maxOccupancy || 1;
        this.maxAdult = data.maxAdult || 0;
        this.maxChild = data.maxChild || 0;
        this.isActive = data.isActive || false;
        this.refId = data.refId || undefined;
        this.media = data.media ? (data.media || []).map(item => new Media(item)) : (this.translate.media || []);
        this.features = data.features || {};
        this.id = data.id || undefined;
        this.hotelId = data.hotelId || undefined;
        this.amenity = (data.amenity || []).map(item => item.id)
        this.numberOfRoom = data.numberOfRoom || undefined;
        this.bedType = data.bedType || undefined
    }

    addMedia(url) {
        this.media.push(new Media({ url, order: this.media.length }))
    }
    setRoomFeatures(field, value) {
        this.features[field] = value;
    }
    removeMedia(media) {
        let removeIndex;
        if (typeof media === 'string') {// by url
            removeIndex = findIndex(this.media, m => getFilenameFromUrl(m.url) === getFilenameFromUrl(media))
        } else if (typeof media === 'object' && media.order >= 0) {//by media object
            removeIndex = findIndex(this.media, m => m.order === media.order)
        } else {
            removeIndex = findIndex(this.media, (m, index) => this.media.indexOf(media) === index);
        }
        if (removeIndex >= 0) this.media = this.media.filter((m, index) => index !== removeIndex);
        this.media = this.media.map((m, index) => {
            if (index >= removeIndex) {
                m.order -= 1;
            }
            return m;
        })
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            code: this.code,
            name: this.name,
            description: this.description,
            shortDescription: this.shortDescription,
            area: this.area,
            maxOccupancy: this.maxOccupancy,
            maxAdult: this.maxAdult,
            maxChild: this.maxChild,
            isActive: this.isActive,
            refId: this.refId,
            hotelId: this.hotelId,
            media: this.media ? (this.media || []).map(item => new Media(item)) : (this.translate.media || []),
            amenity: this.amenity.map(item => ({ id: item })),
            numberOfRoom: this.numberOfRoom,
            bedType: this.bedType,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                homestayRoomTypeId: this.translate.homestayRoomTypeId || this.id,
                name: this.name,
                description: this.description,
                shortDescription: this.shortDescription,
                isActive: this.isActive,
                media: this.media ? (this.media || []).map(item => new Media(item)) : (this.translate.media || []),
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}

export class Media {
    constructor(data = {}) {
        this.url = data.url || undefined;
        this.name = data.name || undefined;
        this.order = data.order || 0;
    }
}
